var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5378_72303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "url(#paint0_linear_5378_72303)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50578 20.7779C15.6277 18.1107 19.71 16.3523 21.7525 15.5027C27.5844 13.077 28.7963 12.6557 29.5861 12.6417C29.7598 12.6387 30.1483 12.6817 30.3999 12.8859C30.6123 13.0583 30.6708 13.2912 30.6987 13.4546C30.7267 13.6181 30.7615 13.9904 30.7338 14.2813C30.4178 17.6019 29.0503 25.6601 28.3546 29.3792C28.0603 30.9529 27.4806 31.4806 26.9195 31.5322C25.7 31.6445 24.7739 30.7263 23.5928 29.952C21.7445 28.7405 20.7004 27.9863 18.9063 26.804C16.8329 25.4377 18.177 24.6867 19.3586 23.4595C19.6678 23.1383 25.041 18.251 25.145 17.8076C25.158 17.7522 25.1701 17.5455 25.0473 17.4363C24.9245 17.3272 24.7433 17.3645 24.6125 17.3942C24.4271 17.4363 21.4745 19.3879 15.7546 23.249C14.9165 23.8245 14.1574 24.1049 13.4772 24.0902C12.7274 24.074 11.2851 23.6662 10.2129 23.3177C8.89773 22.8902 7.8525 22.6642 7.94351 21.9381C7.99092 21.56 8.51168 21.1733 9.50578 20.7779Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5378_72303",
    x1: 2100,
    y1: 0,
    x2: 2100,
    y2: 4168.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5378_72303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tgIcon.d3cb3d62ded66b9daabf350a217d96f3.svg";
export { ForwardRef as ReactComponent };